import * as types from '../mutation-types'

const state = {
  showWidget: false
}

const getters = {
  shouldShowWidget: (state) => {
    return state.showWidget
  }
}

const actions = {
  updateShowWidget ({ commit }, showWidget) {
    commit(types.UPDATE_SHOW_WIDGET, showWidget)
  }
}

const mutations = {
  [types.UPDATE_SHOW_WIDGET] (state, showWidget) {
    state.showWidget = showWidget
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
